import axios from 'axios'
import { environment } from '../config.env';

const ENDPOINT_DOMAIN = process.env.REACT_APP_ENDPOINT_DOMAIN || environment.endpoint_domain || ''

axios.defaults.baseURL = ENDPOINT_DOMAIN;

export function getOauthVerifyIdentityThaiID(role){
    return new Promise(resolve => {
        const path = `/api/v1/uplevel/thaid/getOauthVerifyIdentityThaiID/web/${role}`

        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.get(path, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            // console.log(error)
        })
    })
}


export function verifyThaiDWithRoleUID(code, roleName, uid){
    return new Promise(resolve => {
        let url = `/api/v1/uplevel/thaid/verifyThaiD/web/${roleName}`
        let body = {
            "code": code,
            "role": roleName,
            "uid": uid
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(url, body, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}